import gql from 'graphql-tag';

export const createOrUpdateChannel = gql`
	mutation createOrUpdateChannel($channel: ChannelInput!) {
		createOrUpdateChannel(channel: $channel) {
			name
			language
			territory
			type
			highlights
			mediaLiveId
			mediaPackageId
			sourceAssets {
				items {
					id
					format
					url
					cdnIdentifierArn
				}
			}
		}
	}
`;
